module.exports = __webpack_public_path__ + "media/images/icons/filled/close-circle-fce33e8791005f7a78aaeadad57a8cf7.svg";